import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import PaymentIcon from '@mui/icons-material/Payment';
import Tooltip from '@mui/material/Tooltip';

const PatientPayerPlansButton = props => {
  const {iconOnly, Icon} = props;
  const navigate = useNavigate();
  const patientId = (
    isString(props.patientId) || isNumber(props.patientId)
    ? props.patientId
    : get(props, 'patient.id')
  ) || '';
  const url = `/providers/patients/${patientId}/plans`;
  const onClick = () => navigate(url);
  const childProps = {
    onClick,
    disabled: !patientId,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: iconOnly ? 'primary' : undefined,
    startIcon: iconOnly ? null : (props.Icon ? <Icon/> : <PaymentIcon/>),
    fullWidth: props.fullWidth || null,
  };
  return (
    iconOnly
    ? <Tooltip title='View Insurance Plans'>
      <IconButton {...childProps} sx={{padding: 0}}>
        {props.Icon ? <Icon/> : <PaymentIcon/>}
      </IconButton>
    </Tooltip>
    : <Button {...childProps}>
      Insurance Plans
    </Button>
  );
};

PatientPayerPlansButton.defaultProps = {
  iconOnly: false,
};

PatientPayerPlansButton.propTypes = {
  patient: PropTypes.object,
  patientId: PropTypes.string, // either this or the patient
  iconOnly: PropTypes.bool,
};

export default PatientPayerPlansButton;
